import { useState } from 'react';
import type { HeatmapLayerStyle } from '@alltrails/maps/components/PolylineHeatmapLayer/PolylineHeatmapLayer';
import styles from './HeatmapPocControls.module.scss';
import HeatmapStyleControls from './HeatmapStyleControls';

type Props = {
  hideTrailPins: boolean;
  onHideTrailPinsChange: (hide: boolean) => void;
  style: HeatmapLayerStyle;
  onStyleChange: (style: HeatmapLayerStyle) => void;
};

/**
 * NOT FOR PRODUCTION USE.
 *
 * Admin-only tweaking surface for the polyline heatmap: lets admins hide trail
 * pins and live-edit the heatmap style against the real polyline data fetched
 * from the personal heatmap endpoint. Render-gated to admin sessions while the
 * personal heatmap is active.
 *
 * Unstyled HTML controls on purpose — none of this is meant to match the
 * production design system; it exists to iterate on styling before replacing
 * with a proper admin tool.
 */
const HeatmapPocControls = ({ hideTrailPins, onHideTrailPinsChange, style, onStyleChange }: Props) => {
  const [showStyleControls, setShowStyleControls] = useState(false);

  return (
    <div className={styles.wrapper}>
      <div className={styles.controls}>
        <span className={styles.badge}>Heatmap</span>
        <label className={styles.toggleLabel}>
          <span className={styles.toggleSwitch}>
            <input type="checkbox" aria-label="Hide pins" checked={hideTrailPins} onChange={e => onHideTrailPinsChange(e.target.checked)} />
            <span className={styles.toggleTrack} />
          </span>
          Hide pins
        </label>
        <button type="button" className={styles.customizeBtn} onClick={() => setShowStyleControls(prev => !prev)}>
          {showStyleControls ? 'Hide style' : 'Customize style'}
        </button>
      </div>
      {showStyleControls && <HeatmapStyleControls style={style} onChange={onStyleChange} />}
    </div>
  );
};

export default HeatmapPocControls;
